import {
	FETCH_SUGGESTIONS_FAILURE,
	FETCH_SUGGESTIONS_SUCCESS,
	GET_COMPANY_SUGGESTIONS,
	GET_PORT_SUGGESTIONS,
	GET_SUGGESTIONS
} from '../action/suggestions.action'
import {apiRequest} from "../action/api.action"

export const suggestionsFlow = ({dispatch}) => next => action => {

  next(action)
  
  if(action.type === GET_SUGGESTIONS) {
    let url = `/api/v1/search/vessels?term=${action.payload}&q=${action.payload}`;
    dispatch(apiRequest('GET', url , null, FETCH_SUGGESTIONS_SUCCESS, FETCH_SUGGESTIONS_FAILURE));
  } else if (action.type === GET_COMPANY_SUGGESTIONS) {
    let url = `/api/v2/search?term=${action.payload}&itemTypes=SHIPMANAGER`;
    dispatch(apiRequest('GET', url , null, FETCH_SUGGESTIONS_SUCCESS, FETCH_SUGGESTIONS_FAILURE));
  } else if (action.type === GET_PORT_SUGGESTIONS) {
    let url = `/api/v1/search/port?term=${action.payload}`;
    dispatch(apiRequest('GET', url , null, FETCH_SUGGESTIONS_SUCCESS, FETCH_SUGGESTIONS_FAILURE));
  }
};

export const suggestionsMdl = [suggestionsFlow];